/* pomo-region-filter.js
 * Region-aware filter that complements pomo-delivery.js.
 *  - Reads zone from localStorage postcode + delivery_zone metaobject JSON.
 *  - On collection pages: redirects from one region collection to user's region collection.
 *  - On product pages: shows warning + disables add-to-cart if product.vendor doesn't match.
 *  - On storefront cards: hides cards whose vendor belongs to a different region.
 *  - On postcode change: re-evaluates UI; if region actually changed and cart has items,
 *    asks for confirmation, then clears cart and reloads.
 *
 * Region match key = product.vendor (exact, case/whitespace tolerant) against
 * delivery_zone.vendor field.
 */
(function () {
  if (window.__POMO_REGION_FILTER_INIT__) return;
  window.__POMO_REGION_FILTER_INIT__ = true;

  var STORAGE_POSTCODE_KEY = 'pomo_delivery_postcode';
  var STORAGE_CITY_KEY = 'pomo_delivery_city';
  var WARNING_ID = 'pomo-region-warning';
  var POSTCODE_CHANGED_EVENT = 'pomo:postcode:changed';
  /* Hide the closest grid/carousel wrapper so the empty slot collapses,
   * not just the inner [data-product-vendor] element. */
  var CARD_WRAPPER_SELECTOR = '.grid__item, .swiper-slide, .splide__slide';

  var LANG = (document.documentElement.lang || 'fr').toLowerCase().slice(0, 2);
  var STRINGS = {
    fr: {
      warning_text: 'La livraison de ce produit n’est pas disponible dans votre zone.',
      confirm_clear_cart: 'Changer de zone effacera votre panier. Continuer ?'
    },
    en: {
      warning_text: 'Delivery of this product is not available in your area.',
      confirm_clear_cart: 'Changing zone will empty your cart. Continue?'
    },
    ru: {
      warning_text: 'Доставка этого товара в ваш район недоступна.',
      confirm_clear_cart: 'Смена зоны очистит корзину. Продолжить?'
    }
  };
  var T = STRINGS[LANG] || STRINGS.fr;

  var currentRegionHandle = null;

  function readZones() {
    try {
      var el = document.getElementById('pomo-delivery-zones');
      if (!el) return [];
      var data = JSON.parse(el.textContent || '{}');
      return Array.isArray(data.zones) ? data.zones : [];
    } catch (e) {
      return [];
    }
  }

  function readPostcode() {
    try {
      return (localStorage.getItem(STORAGE_POSTCODE_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function readCity() {
    try {
      return (localStorage.getItem(STORAGE_CITY_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function findZoneByCity(zones, city) {
    if (!city) return null;
    var norm = city.toLowerCase();
    for (var i = 0; i < zones.length; i++) {
      var c = (zones[i].city || '').trim().toLowerCase();
      if (c && c === norm) return zones[i];
    }
    return null;
  }

  function findZoneByPostcode(zones, postcode) {
    if (!postcode) return null;
    for (var i = 0; i < zones.length; i++) {
      var z = zones[i];
      var codes = z && z.postal_codes;
      if (!Array.isArray(codes)) continue;
      for (var j = 0; j < codes.length; j++) {
        var pc = String(codes[j] || '').trim();
        if (pc && postcode.indexOf(pc) === 0) return z;
      }
    }
    return null;
  }

  function getCurrentRegion() {
    var zones = readZones();
    /* Priority 1: postcode (precise). Priority 2: city (fallback). */
    return findZoneByPostcode(zones, readPostcode()) || findZoneByCity(zones, readCity());
  }

  function getKnownRegionHandles(zones) {
    var set = {};
    for (var i = 0; i < zones.length; i++) {
      var h = zones[i] && zones[i].collection_handle;
      if (h) set[h] = true;
    }
    return set;
  }

  function normalizeVendor(s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  }

  function vendorsMatch(a, b) {
    var na = normalizeVendor(a);
    var nb = normalizeVendor(b);
    return na !== '' && na === nb;
  }

  function getKnownVendors(zones) {
    var set = {};
    for (var i = 0; i < zones.length; i++) {
      var v = zones[i] && zones[i].vendor;
      if (v) set[normalizeVendor(v)] = true;
    }
    return set;
  }

  function shouldShowCard(vendor, regionVendor, knownVendors) {
    if (!regionVendor) return true;
    if (!vendor) return true;
    if (vendorsMatch(vendor, regionVendor)) return true;
    if (knownVendors[normalizeVendor(vendor)]) return false;
    return true;
  }

  function filterProductCards(onlyUnchecked) {
    var zones = readZones();
    var region = getCurrentRegion();
    var regionVendor = region ? region.vendor : null;
    var knownVendors = getKnownVendors(zones);

    var selector = onlyUnchecked
      ? '[data-product-vendor]:not([data-pomo-region-checked])'
      : '[data-product-vendor]';
    var cards = document.querySelectorAll(selector);

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.hasAttribute('data-pomo-product-section')) continue;
      var vendor = (card.getAttribute('data-product-vendor') || '').trim();
      var wrapper = card.closest(CARD_WRAPPER_SELECTOR);
      var target = wrapper || card;
      if (shouldShowCard(vendor, regionVendor, knownVendors)) {
        card.style.display = '';
        target.style.display = '';
        card.setAttribute('data-pomo-region-checked', 'ok');
      } else {
        card.style.display = '';
        target.style.display = 'none';
        card.setAttribute('data-pomo-region-checked', 'hide');
      }
    }
  }

  function clearAllChecked() {
    var nodes = document.querySelectorAll('[data-pomo-region-checked]');
    for (var i = 0; i < nodes.length; i++) {
      var card = nodes[i];
      card.removeAttribute('data-pomo-region-checked');
      card.style.display = '';
      var w = card.closest(CARD_WRAPPER_SELECTOR);
      if (w) w.style.display = '';
    }
  }

  var __filterPending = false;
  function scheduleFilterNew() {
    if (__filterPending) return;
    __filterPending = true;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    raf(function () {
      __filterPending = false;
      filterProductCards(true);
    });
  }

  function setupCardObserver() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-product-vendor]:not([data-pomo-region-checked])')) {
            scheduleFilterNew();
            return;
          }
          if (node.querySelector && node.querySelector('[data-product-vendor]:not([data-pomo-region-checked])')) {
            scheduleFilterNew();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function isProductPage() {
    /* Matches /products/handle and locale-prefixed /ru/products/handle, /fr-ca/products/handle, etc. */
    return /(?:^|\/)products\/[^/]/.test(window.location.pathname || '');
  }

  function readProductVendor() {
    var el = document.querySelector('[data-pomo-product-section][data-product-vendor]') ||
             document.querySelector('[data-pomo-product-section]');
    if (!el) return '';
    return (el.getAttribute('data-product-vendor') || '').trim();
  }

  function maybeRedirectCollection() {
    var path = window.location.pathname || '';
    /* Captures optional locale prefix + /collections/ + handle + (rest of path). */
    var m = path.match(/^((?:\/[a-z]{2}(?:-[a-z]+)?)?\/collections\/)([^/]+)(.*)$/i);
    if (!m) return;
    var prefix = m[1];
    var currentHandle = m[2];
    var rest = m[3] || '';
    if (currentHandle === 'all') return;

    var zones = readZones();
    var knownHandles = getKnownRegionHandles(zones);
    if (!knownHandles[currentHandle]) return;

    var region = getCurrentRegion();
    if (!region || !region.collection_handle) return;
    if (region.collection_handle === currentHandle) return;

    var newPath = prefix + region.collection_handle + rest;
    window.location.replace(newPath + window.location.search + window.location.hash);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showRegionWarning(region) {
    if (document.getElementById(WARNING_ID)) return;

    var wrap = document.createElement('div');
    wrap.id = WARNING_ID;
    wrap.setAttribute('role', 'alert');
    wrap.style.cssText =
      'background:#fff4f4;border:1px solid #ff5252;color:#b00020;' +
      'padding:14px 16px;margin:12px 0;border-radius:8px;font-size:14px;line-height:1.4;';

    wrap.innerHTML = '<div>' + escapeHtml(T.warning_text) + '</div>';

    var anchor = document.querySelector('form[action*="/cart/add"]') ||
                 document.querySelector('.product-detail') ||
                 document.querySelector('main') ||
                 document.body;
    if (anchor === document.body || !anchor.parentNode) {
      anchor.appendChild(wrap);
    } else {
      anchor.parentNode.insertBefore(wrap, anchor);
    }
  }

  function clearRegionWarning() {
    var w = document.getElementById(WARNING_ID);
    if (w && w.parentNode) w.parentNode.removeChild(w);
  }

  /* Hide the active filter chip (e.g. "St Petersburg ×") rendered by Glozin
   * for the auto-applied vendor facet. The chip lives in <li class="filter_remove_item">
   * and there is no structural way to distinguish "vendor remove" from other
   * filter chips — so we match by text against known vendor names from zones. */
  function hideVendorChips() {
    var zones = readZones();
    var vendors = {};
    for (var i = 0; i < zones.length; i++) {
      var v = zones[i] && zones[i].vendor;
      if (v) vendors[normalizeVendor(v)] = true;
    }
    var chips = document.querySelectorAll('li.filter_remove_item');
    for (var i = 0; i < chips.length; i++) {
      var text = normalizeVendor(chips[i].textContent || '');
      if (!text) continue;
      for (var v in vendors) {
        if (vendors.hasOwnProperty(v) && text.indexOf(v) !== -1) {
          chips[i].style.display = 'none';
          break;
        }
      }
    }
  }

  function disableAddToCart() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var btns = forms[i].querySelectorAll('button[type="submit"], [name="add"]');
      for (var j = 0; j < btns.length; j++) {
        var b = btns[j];
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.setAttribute('data-pomo-region-disabled', '1');
        b.style.opacity = '0.5';
        b.style.cursor = 'not-allowed';
      }
    }
  }

  function enableAddToCart() {
    var btns = document.querySelectorAll('[data-pomo-region-disabled]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      b.disabled = false;
      b.removeAttribute('aria-disabled');
      b.removeAttribute('data-pomo-region-disabled');
      b.style.opacity = '';
      b.style.cursor = '';
    }
  }

  function maybeShowProductWarning() {
    if (!isProductPage()) return;

    var vendor = readProductVendor();
    if (!vendor) return;

    var region = getCurrentRegion();
    if (!region || !region.vendor) return;

    if (vendorsMatch(vendor, region.vendor)) return;

    showRegionWarning(region);
    disableAddToCart();
  }

  function updateHtmlRegionAttr() {
    var region = getCurrentRegion();
    if (region && region.collection_handle) {
      document.documentElement.setAttribute('data-pomo-region', region.collection_handle);
    } else {
      document.documentElement.removeAttribute('data-pomo-region');
    }
  }

  function reEvaluate() {
    updateHtmlRegionAttr();
    clearRegionWarning();
    enableAddToCart();
    clearAllChecked();
    maybeRedirectCollection();
    maybeShowProductWarning();
    filterProductCards();
  }

  function needsServerReload() {
    /* Collection and search pages need a full reload so Shopify re-renders with
     * the new ?filter.p.vendor= facet. Other pages can re-evaluate in JS. */
    return /^\/(?:[a-z]{2}(?:-[a-z]+)?\/)?(?:collections\/[^/]+|search\/?$)/
      .test(window.location.pathname || '');
  }

  function applyRegionChange(newHandle) {
    currentRegionHandle = newHandle;
    if (needsServerReload()) {
      var url = new URL(window.location.href);
      url.searchParams.delete('filter.p.vendor');
      window.location.replace(url.toString());
    } else {
      reEvaluate();
    }
  }

  function onPostcodeChanged() {
    var newRegion = getCurrentRegion();
    var newHandle = newRegion ? newRegion.collection_handle : null;

    /* Keep city in sync with the new postcode so /nice deep-link, popup state,
     * and the delivery widget all agree on the same city. */
    if (newRegion && newRegion.city) {
      try { localStorage.setItem(STORAGE_CITY_KEY, newRegion.city); } catch (e) {}
    }

    if (currentRegionHandle === null) {
      applyRegionChange(newHandle);
      return;
    }

    if (newHandle === currentRegionHandle) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var hasItems = cart && cart.item_count > 0;
        if (hasItems) {
          var ok = window.confirm(T.confirm_clear_cart);
          if (!ok) return;
          return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
            .then(function () {
              currentRegionHandle = newHandle;
              window.location.reload();
            });
        }
        applyRegionChange(newHandle);
      })
      .catch(function () {
        applyRegionChange(newHandle);
      });
  }

  function init() {
    var region = getCurrentRegion();
    currentRegionHandle = region ? region.collection_handle : null;

    updateHtmlRegionAttr();
    maybeRedirectCollection();
    maybeShowProductWarning();
    filterProductCards();
    hideVendorChips();
    setupCardObserver();

    document.addEventListener(POSTCODE_CHANGED_EVENT, onPostcodeChanged);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
